import React, { useState, useRef, useEffect } from "react";
import { Box, Card, CardHeader, CardContent, Typography} from '@mui/material';
import { isMobile } from 'react-device-detect';
import ClientGraphContainer from '../components/client_version/ClientGraphContainer';
import { Button } from 'react-bootstrap';
import AirCompressorModal from '../../../AirModal';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import AirLeakGraph from "./AirLeakGraph";
import AirCard from "./AirCard";
import AirGraphContainer from "./AirGraphContainer";

const AirCompressors = props => {
  const containerRef = useRef(null);
  const compressorRefs = useRef([]);
  const dryerRef = useRef(null);
  const pressureRef = useRef(null);

  const [lines, setLines] = useState([]);

  useEffect(() => {
    const calculateLines = () => {
      if (!containerRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();

      const getRelativeCenterRight = (el) => {
        const rect = el.getBoundingClientRect();
        return {
          x: rect.right - containerRect.left,
          y: rect.top + rect.height / 2 - containerRect.top
        };
      };

      const getRelativeCenterLeft = (el) => {
        const rect = el.getBoundingClientRect();
        return {
          x: rect.left - containerRect.left,
          y: rect.top + rect.height / 2 - containerRect.top
        };
      };

      const compressorPoints = compressorRefs.current.map(getRelativeCenterRight);
      const dryerPoint = getRelativeCenterLeft(dryerRef.current);
      const pressurePoint = getRelativeCenterLeft(pressureRef.current);

      const mergeX = Math.min(...compressorPoints.map(p => p.x)) + 40;

      const newLines = [];

      // Individual lines to merge
      compressorPoints.forEach(point => {
        newLines.push(
          `M ${point.x} ${point.y} L ${mergeX} ${point.y}`
        );
      });

      // Vertical merge trunk
      newLines.push(
        `M ${mergeX} ${compressorPoints[0].y} 
         L ${mergeX} ${compressorPoints[compressorPoints.length - 1].y}`
      );

      const middleY = compressorPoints[1].y;

      // Merge to dryer
      newLines.push(
        `M ${mergeX} ${middleY} L ${dryerPoint.x} ${dryerPoint.y}`
      );

      // Dryer to pressure
      newLines.push(
        `M ${dryerPoint.x + 160} ${dryerPoint.y} 
         L ${pressurePoint.x} ${pressurePoint.y}`
      );

      setLines(newLines);
    };

    calculateLines();
    window.addEventListener("resize", calculateLines);
    return () => window.removeEventListener("resize", calculateLines);
  }, []);
    const [showModal, setShowModal] = useState(false);
    return (

        
  <div>
    <br />
    

    {/* MAIN CONTAINER */}
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        padding: 3
      }}
    >
      
      <Box sx={{ width: "100%" }}>
        <AirGraphContainer
          userData={props.userData}
          aircompressors ={true}
          page="Overview"
        />
      </Box>
      <br />
      
      <Box
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 3
        }}
      >
        {/* Leak Graph */}
        <Box sx={{ flex: 2 }}>
          <h4 style={{ textAlign: "center" }}>
            Weekly KW Leaks
          </h4>
          <AirLeakGraph
            userData={props.userData}
            aircompressors = {true}
            page="Overview"
          />
        </Box>
      </Box>
    </Box>
  </div>
);
};

export default AirCompressors;

